import { cva } from 'class-variance-authority'

import { cn } from '@components/../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-badge border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary: 'border-transparent bg-muted text-foreground hover:bg-muted/80',
        destructive: 'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground border-border',
        success: 'border-transparent bg-success-light text-success',
        warning: 'border-transparent bg-warning-light text-warning',
        error: 'border-transparent bg-error-light text-error',
        info: 'border-transparent bg-info-light text-info',
        'status-new': 'border-status-new text-status-new bg-transparent',
        'status-reviewed': 'border-status-reviewed text-status-reviewed bg-transparent'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
)

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
